
export const fetchPartnersLogos = () => {
  return [
    { source: "/assets/partners/08.png" },
    { source: "/assets/partners/07.png" },
    { source: "/assets/partners/01.png" },
    { source: "/assets/partners/02.png" },
    { source: "/assets/partners/03.png" },
    { source: "/assets/partners/04.png" },
    { source: "/assets/partners/05.png" },
    { source: "/assets/partners/06.png" },
    // { source: "/assets/partners/07.png" },
    // { source: "/assets/partners/08.png" },
    { source: "/assets/partners/09.png" },
    { source: "/assets/partners/10.png" },
    { source: "/assets/partners/11.png" },
    { source: "/assets/partners/12.png" },
    { source: "/assets/partners/13.png" },
    { source: "/assets/partners/14.png" },
    { source: "/assets/partners/15.png" },
    { source: "/assets/partners/16.png" },
    { source: "/assets/partners/17.png" },
    { source: "/assets/partners/18.png" },
    { source: "/assets/partners/19.png" },
    { source: "/assets/partners/20.png" },
    { source: "/assets/partners/21.png" },
    { source: "/assets/partners/22.png" },
    { source: "/assets/partners/23.png" },
    { source: "/assets/partners/24.png" },
    { source: "/assets/partners/25.png" },
    { source: "/assets/partners/26.png" },
    { source: "/assets/partners/27.png" },
    { source: "/assets/partners/28.png" },
    { source: "/assets/partners/29.png" },
    { source: "/assets/partners/30.png" },
    { source: "/assets/partners/31.png" },
    { source: "/assets/partners/32.png" },
    { source: "/assets/partners/33.png" },
    { source: "/assets/partners/34.png" },
    { source: "/assets/partners/35.png" },
    // { source: "/assets/partners/36.png" },
    { source: "/assets/partners/37.png" },
    { source: "/assets/partners/38.png" },
    { source: "/assets/partners/39.png" },
    { source: "/assets/partners/40.png" },
    { source: "/assets/partners/41.png" },
    { source: "/assets/partners/42.png" },
    { source: "/assets/partners/43.png" },
    { source: "/assets/partners/44.png" },
    { source: "/assets/partners/45.png" },
  ];
};
